<template>
    <div>
        <el-input v-model="newBrief"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveDesc">保存</el-button>
        </span>
    </div>
</template>
<script>
export default {
    name:"Brief",
    props:['brief'],
    data (){
        return {
            newBrief:this.brief
        }
    },
    methods:{
        saveDesc(){
            this.$emit('saveBrief',tihs.newBrief)
        }
    }
}
</script>